const translations = {
	page_title: "Consortium Financement",
	title: "Un relais pour le financement de vos clients",
	description:
		"Consortium Financement prend en charge les demandes de financement de vos clients. Inscrivez-vous depuis Wenimmo pour être recontacté et mettre en place le partenariat.",
	process_title: "Les étapes",
	preview: {
		title: "Mode recette local",
		description: "Change l'affichage et simule l'envoi localement. Aucune donnée Consortium n'est modifiée.",
		real: "Données réelles",
		form_with_mobile: "Formulaire - téléphone renseigné",
		form_without_mobile: "Formulaire - téléphone absent",
		en_attente: "Statut - en attente",
		en_cours: "Statut - en cours",
		valide: "Statut - actif",
		refuse: "Statut - non retenu",
		origin_cf: "Déjà partenaire Consortium",
		submit_success: "Simulation terminée. Aucune donnée n'a été envoyée à Consortium.",
	},
	steps: {
		request: {
			title: "Envoi de la demande",
			text: "Wenimmo transmet vos coordonnées à Consortium.",
		},
		contact: {
			title: "Échange avec Consortium",
			text: "Leur équipe vous contacte pour finaliser le partenariat.",
		},
		activation: {
			title: "Partenariat activé",
			text: "Le service est disponible dès que votre dossier est validé.",
		},
	},
	load_error: "Nous ne parvenons pas à charger votre inscription Consortium pour le moment.",
	retry: "Réessayer",
	form: {
		title: "Votre demande",
		description: "Vérifiez les informations qui seront transmises à Consortium Financement.",
		advisor: "Conseiller",
		email: "E-mail",
		mobile: "Téléphone mobile *",
		mobile_caption: "Consortium utilisera ce numéro pour vous recontacter.",
		mobile_missing_caption: "Aucun téléphone n'est renseigné sur votre compte. Saisissez celui sur lequel Consortium peut vous joindre.",
		cabinet: "Cabinet",
		orias_number: "Numéro ORIAS",
		consent:
			"En envoyant la demande, vous autorisez Wenimmo à transmettre ces informations à Consortium Financement. Les éventuels documents joints seront également transmis.",
		submit: "Envoyer la demande",
	},
	documents: {
		title: "Documents à joindre (facultatif)",
		description: "Vous pouvez envoyer la demande sans document. Si vous les avez déjà : PDF, JPG ou PNG, 10 Mo maximum par fichier.",
		orias: "Attestation ORIAS (facultatif)",
		rcp: "Attestation RCP (facultatif)",
		add: "Déposer un document",
		drop: "Ou glissez-déposez le fichier ici",
		later: "Les documents sont facultatifs. Vous pourrez aussi les transmettre directement à Consortium lors de vos échanges.",
	},
	status: {
		tracking_title: "Suivi de la demande",
		identifier: "Identifiant Consortium",
		requested_at: "Demande envoyée",
		updated_at: "Statut mis à jour",
		last_sync: "Dernière vérification",
		automatic_sync: "Le statut est vérifié automatiquement chaque jour. Vous pouvez aussi le mettre à jour maintenant.",
		refresh: "Actualiser le statut",
		refreshing: "Actualisation en cours…",
		refresh_success: "Le statut Consortium est à jour.",
		origin_cf: "Votre partenariat existait déjà chez Consortium Financement. Il est bien reconnu et actif dans Wenimmo.",
		en_attente: {
			label: "En attente",
			title: "Votre demande a bien été transmise",
			text: "L'équipe Consortium Financement va prendre connaissance de vos informations et revenir vers vous.",
		},
		en_cours: {
			label: "En cours",
			title: "Votre inscription est en cours",
			text: "Les échanges avec Consortium Financement sont en cours. Votre accès sera activé après validation.",
		},
		valide: {
			label: "Actif",
			title: "Votre partenariat est actif",
			text: "Votre inscription a été validée par Consortium Financement.",
		},
		refuse: {
			label: "Non retenu",
			title: "Votre demande n'a pas été retenue",
			text: "Vous pouvez vous rapprocher de Consortium Financement pour obtenir davantage d'informations.",
		},
	},
};

export default translations;
